import React from 'react'

function LetterHead({item,src}:any) {
  return (
    <img
    style={{
      position: "absolute",
      top: item?.top,
      left: item?.left,
      height: item?.height,
      width: item?.width,
      display: item?.show ? "" : "none",
    }}
     crossOrigin="anonymous"
    src={src}
    alt=""
  />
  )
}

export default LetterHead